import React from 'react';
import { Modal } from 'antd';
import PageLoading from 'components/Loading/PageLoading';
import { normal, antdNotice, MyModal } from 'components/Notification';
import { routerRedux } from 'dva/router';
import { isPC } from '@/utils/common/common';
import Toast from 'antd-mobile/lib/toast';
import 'antd-mobile/lib/toast/style/css';
import $$ from 'cmn-utils';
import {
	forceHomepage,
} from '@/utils/common';
// import createHistory from 'history/createHashHistory';
//import { message, } from 'antd';

/**
 * 应用配置 如请求格式，反回格式，异常处理方式，分页格式等
 */
export default (() => {
	//系统通知, 定义使用什么风格的通知，normal或antdNotice
	const notice = normal;
	const isPc = isPC();

	return {
		/**
		 * 系统通知, 定义使用什么风格的通知，normal或antdNotice
		 */
		notice: notice,

		// 异步请求配置
		request: {
			prefix: '/cdmsA',//A版打包
			//prefix: '/cdms',//B版打包

			// 每次请求头部都会带着这些参数
			withHeaders: () => ({
				//token: store.getStore("token"),
			}),

			/**
			 * 因为modelEnhance需要知道服务器反回的数据，
			 * 什么样的是成功，什么样的是失败，如
			 * {status: true, data: ...} // 代表成功
			 * {status: false, message: ...} // 代表失败
			 * 实际中应该通过服务端反回的response中的
			 * 成功失败标识来进行区分
			 */
			afterResponse: (response, info) => {
				let url = window.location.href;
				let indexWechat = url.indexOf('/sign/wechat');
				const { code, msg } = response;
				if (code === '200') {
					return response;
				} else {
					// console.log("config afterResponse", response, info)
					//如果异常代码是1003000，表示用户会话过期，弹框退出页面
					if (code === '1003000' || code === "1003869" || code === '1003873') {
						forceHomepage();
					} else if ((code === '1001024' || code === '1001025'
						|| code === '1003039' || code === '1003002' || code === '1003035') && indexWechat > 0) {
						//微信扫码绑定终端需要过滤全局提示	
					} else if( code === '100012') {
						//充值页面
					} else {
						isPc ? notice.error(window.language['responseCode.' + code]) : Toast.fail(window.language['responseCode.' + code], 1)
					}
				}
				return response;
			},
			errorHandle: (err, info) => {
				// console.log("config errorHandle", err.name,)
				// 请求错误全局拦截
				if (err.name === 'RequestError') {
					let contentMsg = window.language['common.bgProgramAccessFailed'];

					isPc
						?
						notice.error({
							title: window.language['material.notice'],
							className: 'custom-modal',
							content: contentMsg,
							message: contentMsg,
							onOk: () => {
								window.location.href = window.contextPath + '#/sign/login';
							}
						})
						:
						Toast.offline(contentMsg, 1);
				} else {
					console.error(err);
				}
			}
		},

		// 全局异常
		exception: {
			global: (err, dispatch) => {
				// RequestError为拦截请求异常
				if (err.name === 'RequestError') {
					let contentMsg = window.language['common.bgProgramAccessFailed'];

					isPc
						?
						notice.error({
							title: window.language['material.notice'],
							className: 'custom-modal',
							content: contentMsg,
							message: contentMsg,
							onOk: () => {
								window.location.href = window.contextPath + '#/sign/login';
							}
						})
						:
						Toast.offline(contentMsg, 1);
				} else {
					// notice.error(err.message);
					isPc ? notice.error(err.message) : Toast.fail(err.message, 1)
					console.error(err);
				}
				// notice.error(err.message);
			}
		},

		// 分页助手
		pageHelper: {
			// 格式化要发送到后端的数据
			requestFormat: (pageInfo) => {
				const { pageNum, pageSize, filters, sorts } = pageInfo;
				return {
					currentPage: pageNum,
					showCount: pageSize,
					sortMap: sorts,
					paramMap: filters
				};
			},

			// 格式化从后端反回的数据
			responseFormat: (resp) => {
				const { currentPage, showCount, totalResult, dataList, totalPage } = resp.data;
				return {
					pageNum: currentPage,
					pageSize: showCount,
					total: totalResult,
					totalPages: totalPage,
					list: dataList
				};
			}
		},

		// 路由加载效果
		router: {
			loading: <PageLoading loading />
		},

		/**
		 * 模拟数据时包装反回数据
		 * 因为，后端反回数据时一般都会在外边包装一层状态信息
		 * 如成功时：
		 * {
		 *   status: true,
		 *   data: responseData
		 * }
		 * 或出错时：
		 * {
		 *   status: false,
		 *   code: 500,
		 *   message: '用户名或密码错误'
		 * }
		 * 这里就是配置这两个函数，为了我们模拟数据时可以少写几行代码的 orz...
		 */
		mock: {
			toSuccess: (response) => ({
				status: true,
				data: response
			}),

			toError: (message) => ({
				status: false,
				message: message
			})
		}
	};
})();



// WEBPACK FOOTER //
// ./src/config.js